export default __webpack_public_path__ + "static/media/rules-initial.464ec322.svg";